import { Directive, ElementRef, OnInit } from "@angular/core";
import { environment } from "../../../environments/environment";

/**
 * Directive that removes `data-cy` attributes from elements in production builds.
 *
 * The `data-cy` attributes are used by Cypress component tests as stable selectors.
 * They should not be shipped to production as they:
 * - Expose internal test structure to end users
 * - Increase HTML payload size
 *
 * This directive auto-applies to any element with a `data-cy` attribute and removes
 * it at runtime when `environment.production` is `true`.
 *
 * Usage: Simply add `data-cy="..."` to any element — no additional setup required
 * once this directive is imported in the component's `imports` array.
 */
@Directive({
  selector: "[data-cy]",
  standalone: true,
})
export class DataCyDirective implements OnInit {
  constructor(private readonly el: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    if (environment.production) {
      this.el.nativeElement.removeAttribute("data-cy");
    }
  }
}
